var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserService } from './user.service';
import { TranslateService } from '@ngx-translate/core';
import { HasSubscriptions } from '../components/has-subscriptions';
import { of, Subject } from 'rxjs';
var RoutingHistoryService = /** @class */ (function (_super) {
    __extends(RoutingHistoryService, _super);
    function RoutingHistoryService(userService, translate) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.translate = translate;
        _this.historyItemChangedEvent = new Subject();
        _this.addSub(_this.userService.currentUser.subscribe(function (user) {
            _this._user = user;
        }));
        return _this;
    }
    Object.defineProperty(RoutingHistoryService.prototype, "backToText", {
        get: function () {
            return this._lastHistoryItem && this._lastHistoryItem.translateValue ? this.translate.get(this._lastHistoryItem.translateValue) : of('');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingHistoryService.prototype, "lastHistoryItem", {
        get: function () {
            return this._lastHistoryItem || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingHistoryService.prototype, "returnUrl", {
        get: function () {
            return this._lastHistoryItem ? this._lastHistoryItem.returnUrl : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingHistoryService.prototype, "returnQueryParams", {
        get: function () {
            return this._lastHistoryItem ? this._lastHistoryItem.returnQueryParams : null;
        },
        enumerable: true,
        configurable: true
    });
    // this function should be used on next page's ngOnInit
    RoutingHistoryService.prototype.push = function (currentRoute) {
        // Set user's last history so we know where to send them back to.
        // Need to copy the history otherwise lastHistoryItem will be updated by reference
        var history = [];
        Object.assign(history, this._user.session.history);
        this._lastHistoryItem = history[history.length - 1];
        this.historyItemChangedEvent.next();
        // Push to history if user is not navigating to a LDP
        // If navigating to LDP, need to check if previous route is also a LDP
        if (!this.isLDP(currentRoute.returnUrl[0])) {
            this._user.session.history.push(currentRoute);
        }
        else if (this._lastHistoryItem && !this.isLDP(this._lastHistoryItem.returnUrl[0])) {
            this._user.session.history.push(currentRoute);
        }
    };
    RoutingHistoryService.prototype.isLDP = function (url) {
        return url.endsWith('-lst/') || url.endsWith('-lst');
    };
    RoutingHistoryService.prototype.pop = function () {
        // Remove the last 2 history items from the array since we are going back there now.
        // Last one is the current page which is no longer needed, 2nd last is the page we are going back to.
        this._user.session.history.pop();
        this._user.session.history.pop();
    };
    return RoutingHistoryService;
}(HasSubscriptions));
export { RoutingHistoryService };
